var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"w-full min-h-screen flex flex-col items-center justify-center",attrs:{"src":_vm.m4uRechargeUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }